module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/android11Logo.c136a7f2.png";